<template>
  <app-content class="h-panel">
    <div class="h-panel-bar"><span class="h-panel-title">多栏账{{ subject ? ' - ' + subject.name : '' }}</span></div>
    <Row type="flex" :space-x="10" class="margin-right-left margin-top no-print">
      <Cell>
        <Select v-model="subjectId" :datas="subjectList" keyName="id" titleName="name" :width="220"
                :filterable="true" placeholder="选择科目" @change="onSubjectChange"></Select>
      </Cell>
      <Cell>
        <DatePicker type="month" v-model="period" format="YYYY-MM" style="width: 140px"
                    :clearable="false"></DatePicker>
      </Cell>
      <Cell>
        <span class="range-sep">至</span>
        <DatePicker type="month" v-model="endMonth" format="YYYY-MM" style="width: 140px"
                    placeholder="结束月份(可选)" :clearable="true"></DatePicker>
      </Cell>
      <Cell>
        <Button color="primary" icon="fa fa-search" :loading="loading" @click="doSearch">查询</Button>
        <Button @click="doExport">导出</Button>
        <Button icon="fa fa-print" @click="doPrint">打印</Button>
      </Cell>
    </Row>
    <div class="h-panel-body" style="overflow-x: auto;">
      <div class="print-header">
        <div class="print-title">多栏账{{ subject ? ' - ' + subject.name : '' }}</div>
        <div class="print-sub">
          <span>编制单位：{{currentAccountSets?currentAccountSets.companyName:''}}</span>
          <span>期间：{{printPeriod}}</span>
          <span>单位：元</span>
        </div>
      </div>
      <table class="cus-table multi-table">
        <thead>
        <tr>
          <th>日期</th>
          <th>凭证字号</th>
          <th>摘要</th>
          <th>借方发生额</th>
          <th>贷方发生额</th>
          <th>方向</th>
          <th>余额</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in showList" :key="index">
          <td>{{ item.voucherDate }}</td>
          <td>
            <router-link v-if="item.voucherId" :to="{name:'VoucherForm',params:{voucherId:item.voucherId}}">
              {{ item.word }}-{{ item.code }}
            </router-link>
          </td>
          <td>{{ item.summary }}</td>
          <td align="right">{{ item.debitAmount | numFormat }}</td>
          <td align="right">{{ item.creditAmount | numFormat }}</td>
          <td align="center" :class="{'abnormal-balance':isAbnormalBalance(item)}">{{ item.balanceDirection }}</td>
          <td align="right" :class="{'abnormal-balance':isAbnormalBalance(item)}">{{ item.balance | numFormat }}</td>
        </tr>
        <tr v-if="!showList.length">
          <td colspan="7" class="text-center padding">暂无数据</td>
        </tr>
        </tbody>
        <tfoot v-if="showList.length">
        <tr>
          <td colspan="3" align="right"><b>本期合计</b></td>
          <td align="right"><b>{{ sum('debitAmount') | numFormat }}</b></td>
          <td align="right"><b>{{ sum('creditAmount') | numFormat }}</b></td>
          <td></td>
          <td align="right"><b>{{ lastBalance | numFormat }}</b></td>
        </tr>
        </tfoot>
      </table>
    </div>
  </app-content>
</template>

<script>
import moment from 'moment';
import {mapState} from 'vuex';
import {exportCsv} from '../../js/common/export-file';

export default {
  name: 'MultiColumnLedger',
  data() {
    return {
      subjectList: [],
      subjectId: null,
      subject: null,
      period: moment().format('YYYY-MM'),
      endMonth: null,
      allList: [],
      loading: false
    }
  },
  computed: {
    ...mapState(['currentAccountSets']),
    printPeriod() {
      if (!this.period) {
        return '';
      }
      let s = moment(this.period, 'YYYY-MM').format('YYYY年MM月');
      if (this.endMonth && moment(this.endMonth, 'YYYY-MM').isAfter(moment(this.period, 'YYYY-MM'), 'month')) {
        s += ' 至 ' + moment(this.endMonth, 'YYYY-MM').format('YYYY年MM月');
      }
      return s;
    },
    //期初行+凭证明细行（剔除后端返回的本期/本年汇总行，汇总由表格底部计算）
    showList() {
      return this.allList.filter(item => item.voucherId || item.summary === '期初余额');
    },
    //本期凭证明细行
    detailRows() {
      return this.showList.filter(item => item.voucherId);
    },
    lastBalance() {
      let list = this.showList;
      return list.length ? list[list.length - 1].balance : 0;
    }
  },
  watch: {
    endMonth() {
      this.loadList();
    }
  },
  methods: {
    sum(field) {
      return this.detailRows.reduce((total, item) => total + (Number(item[field]) || 0), 0);
    },
    onSubjectChange() {
      this.subject = this.subjectList.find(item => item.id === this.subjectId) || null;
    },
    //余额方向与科目默认方向相反且余额非零时视为异常（如费用类科目挂出借方负数余额），红字提示
    isAbnormalBalance(item) {
      return !!(this.subject && this.subject.balanceDirection
        && item.balanceDirection && item.balanceDirection !== '平'
        && item.balanceDirection !== this.subject.balanceDirection
        && Number(item.balance) !== 0);
    },
    loadSubjects() {
      this.$api.setting.subject.voucherSelect({}).then(({data}) => {
        this.subjectList = data || [];
        if (this.subjectList.length) {
          this.subjectId = this.subjectList[0].id;
          this.onSubjectChange();
        }
        this.loadList();
      }).catch(() => {
      });
    },
    loadList() {
      if (!this.subjectId) {
        return;
      }
      this.loading = true;
      //复用明细账接口：含期初余额、按科目余额方向滚动余额，后端已排除草稿/作废凭证
      let params = {
        accountDate: this.period,
        subjectId: this.subjectId,
        subjectCode: this.subject ? this.subject.code : null
      };
      if (this.endMonth && moment(this.endMonth, 'YYYY-MM').isAfter(moment(this.period, 'YYYY-MM'), 'month')) {
        params.endAccountDate = moment(this.endMonth, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      }
      this.$api.accountbook.loadVoucherDetails(params).then(({data}) => {
        this.allList = data || [];
      }).catch(() => {
        this.$Message.error('多栏账数据加载失败');
      }).finally(() => this.loading = false);
    },
    doSearch() {
      this.loadList();
    },
    doExport() {
      let headers = ['日期', '凭证字号', '摘要', '借方发生额', '贷方发生额', '方向', '余额'];
      let rows = this.showList.map(item => [
        item.voucherDate, item.voucherId ? item.word + '-' + item.code : '', item.summary,
        item.debitAmount, item.creditAmount, item.balanceDirection, item.balance
      ]);
      exportCsv('多栏账' + (this.period ? '-' + moment(this.period, 'YYYY-MM').format('YYYYMM') : '') + (this.endMonth ? '-' + moment(this.endMonth, 'YYYY-MM').format('YYYYMM') : ''), headers, rows);
    },
    doPrint() {
      window.print();
    }
  },
  mounted() {
    this.loadSubjects();
  }
}
</script>

<style lang="less" scoped>
.range-sep {
  margin: 0 8px;
  line-height: 30px;
  vertical-align: middle;
}
.abnormal-balance {
  color: #f56c6c;
  font-weight: bold;
}
.multi-table {
  width: 100%;
  border-collapse: collapse;

  th, td {
    padding: 8px 10px;
    border: 1px solid #e2e2e2;
    font-size: 13px;
  }

  th {
    background: #f5f5f5;
    text-align: center;
  }

  tbody tr:nth-child(even) {
    background: #fafafa;
  }

  tfoot td {
    background: #f5f5f5;
  }
}
</style>
